import React from 'react';
import ProductsBatch from '../components/ProductsBatch';
import fetcher from "../API";
import { message } from 'antd';
import _ from 'lodash';

class CategoryChange extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            productIds: [],
            error: null
        };
    }

    onProductCategoryInputChange(value) {
        this.setState({ categoryIds: value});
    }
    onProductCategoryChangeInTextArea(contents) {
        contents = contents.filter(d=>d)
        this.setState({ productIds2: contents });
    }
    onClickAddProductCategoryButton() {
        let { categoryIds, productIds2 } = this.state
        this.changeProductCategory(productIds2, categoryIds, 0)
    }
    changeProductCategory(productIds, categoryIds, index=0) {
        fetcher.post(`api/v1/products/${productIds[index]}/manual`, {categoryIds}).then((response) => {
            message.success(`${productIds[index]}保存成功`);
            if(index < productIds.length-1){
                this.changeProductCategory(productIds, categoryIds, ++index)
            }
        }).catch(error => {
            if(_.get(error, 'response.data.errors')){
                message.error(`${productIds[index]}失败：${_.get(error, 'response.data.errors')[0]}`);
            }else if(_.get(error, 'response.status') === 304){
                message.success(`${productIds[index]}保存成功`);
            }else{
                message.error(`${productIds[index]}失败`)
            }
            if(index < productIds.length-1){
                this.changeProductCategory(productIds, categoryIds, ++index)
            }
        });
    }
    render() {
        return (
            <div className='mt-5'>
                <ProductsBatch title = "ProductIds:(每个id占一行，不允许空行)"
                onCategoryInputChange={ this.onProductCategoryInputChange.bind(this) }  
                onTextViewChange={ this.onProductCategoryChangeInTextArea.bind(this) }
                saveProductsCategory={ this.onClickAddProductCategoryButton.bind(this) } />
            </div>
        )
    }
}

export default CategoryChange; 